import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SFOnDutyApi } from '../../shared/sdk/index';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the OnDutyTypesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OnDutyTypesProvider {

  

  constructor(
    public http: HttpClient,
    public SFOnDutyApi:SFOnDutyApi,
  ) {
    console.log('Hello OnDutyTypesProvider Provider');
  }

  get(): Observable<any>{
    return new Observable((observer)=>{
      console.log('this onduty',this.SFOnDutyApi);
      this.SFOnDutyApi.getOnDutyPurposeTypes().subscribe(
        result=>{
          observer.next(result);
          observer.complete();
        }
        ,error=>{
          observer.error(error);
        }
      )
     
    })
  } 
}



// WEBPACK FOOTER //
// ./src/providers/on-duty-types/on-duty-types.ts